/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
import { colors } from "../../theme";
import CTAGroup from "../CTAGroup";
import useModal from "./useModal";

export const ModalOverlay = ({ ...props }) => (
    <div
        {...props}
        css={css`
            position: fixed;
            top: 0px;
            bottom: 0px;
            left: 0px;
            right: 0px;
            z-index: 19;
            background-color: rgba(0, 0, 0, 0.6);
        `}
    ></div>
);

export const ModalContainer = ({ children }) => (
    <div
        data-testid="modal-container"
        css={css`
            position: fixed;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            overflow: auto;
            z-index: 20;
            max-height: 478px;
            width: 100%;
            max-width: 362px;
            background-color: ${colors.neutral0};
            box-shadow: 0px 6px 64px rgba(0, 0, 0, 0.4);
            border-radius: 6px;
            padding: 32px;
        `}
    >
        {children}
    </div>
);

const CloseButton = ({ onClick }) => (
    <div
        css={css`
            flex: 1;
        `}
    >
        <button
            data-testid="close-button"
            css={css`
                font-size: 26px;
                align-self: center;
                color: ${colors.neutral6};
                float: right;
                background-color: transparent;
                border: 0;
                position: absolute;
                right: 16px;
                top: 16px;
            `}
            onClick={onClick}
        >
            &#215;
        </button>
    </div>
);

export const ModalTitle = ({ children }) => (
    <div
        css={css`
            font-size: 21px;
            line-height: 26px;
            font-weight: bold;
            margin-bottom: 24px;
        `}
    >
        {children}
    </div>
);

export const ModalSubTitle = ({ children }) => (
    <div
        css={css`
            font-size: 16px;
            line-height: 24px;
            opacity: 0.75;
            margin-bottom: 24px;
        `}
    >
        {children}
    </div>
);

const Modal = () => {
    const { modalProps, closeModal } = useModal();

    if (!modalProps) {
        return null;
    }

    const { renderTitle, renderSubTitle, children, renderActions } = modalProps;

    return (
        <>
            <ModalOverlay />
            <ModalContainer>
                <CloseButton onClick={closeModal} />
                {!!renderTitle && (
                    <ModalTitle>{renderTitle({ closeModal })}</ModalTitle>
                )}
                {!!renderSubTitle && (
                    <ModalSubTitle>
                        {renderSubTitle({ closeModal })}
                    </ModalSubTitle>
                )}
                {children}
                {!!renderActions && (
                    <CTAGroup>{renderActions({ closeModal })}</CTAGroup>
                )}
            </ModalContainer>
        </>
    );
};

export default Modal;
